import { ApiResult, request, safeRequest } from '@synergy/api';

import { EclassDto } from '../models/eclass-dto';

export class EclassApi {
    constructor(protected baseUrl: string) {}

    public cget(): Promise<ApiResult<EclassDto[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/eclasses?rootOnly=true&limit=1000`),
            response => response.data.items
        );
    }
}
